/**
 * Single browser entry point.
 *
 * This replaces THREE Gatsby files that between them did one small job:
 *
 *   gatsby-browser.js   wrapRootElement - ThemeProvider + GlobalStyle + EnvBorder
 *   gatsby-ssr.js       the same function again, character for character
 *   src/pages/index.tsx rendered <App />
 *
 * The tree below is that wrapper with <App /> inside it, so what mounts is
 * identical to what Gatsby mounted.
 *
 * ReactDOM.render, not createRoot: React is 16.12 here and createRoot does not
 * exist until 18. That is deliberate - see PORTAL-43. Moving to React 18 also
 * forces @reach/router out (it declares "react": "15.x || 16.x"), which is a
 * separate, larger change and is not required to make Netlify build again.
 */

import React, { Fragment } from 'react';
import ReactDOM from 'react-dom';
import { ThemeProvider } from 'styled-components';

import THEME from './assets/styles/config';
import GlobalStyle from './assets/styles/globalStyle';
import EnvBorder from './components/envBorder';
import App from './app/app';

ReactDOM.render(
  <ThemeProvider theme={THEME}>
    <Fragment>
      <GlobalStyle />
      <EnvBorder />
      <App />
    </Fragment>
  </ThemeProvider>,
  document.getElementById('root'),
);
